import { Grid, Typography, withStyles } from "@material-ui/core";
import {
  Button,
  Checkbox,
  InputField,
  LoadingIcon,
} from "bc-front-sagacomponents";
import React, { useEffect } from "react";
import { FormProvider } from "react-hook-form";
import { bicFormat, ibanFormat } from "../../../../helpers/formatters";
import { useGetAdherent } from "../../../../hooks/useGetAdherent";
import Check from "../../../../images/Check";
import Croix from "../../../../images/Croix";
import styles from "../../style";
import { useRenouvellementPrelevement } from "./selectors";

interface Props {
  classes?: any;
  selectedAdhesionId?: string;
  setConfirmationMandat(param): void;
  confirmationMandat: boolean;
}
const Prelevement = (props: Props) => {
  const {
    classes,
    selectedAdhesionId,
    setConfirmationMandat,
    confirmationMandat,
  } = props;

  const { listeAdherents } = useGetAdherent();
  const selectedAdherent = listeAdherents?.find((adh) =>
    adh.listAdhesion?.find((a) => a.numeroAdhesion === selectedAdhesionId)
  );
  const {
    watch,
    paramsMandat,
    setParamsMandat,
    methods,
    onSubmit,
    register,
    clearErrors,
    setValue,
    errors,
    handleSubmit,
    verifyMandat,
    fetchingVerifyMandat,
    errorVerifyMandat,
    responseMandat,
    fetchingMandat,
    errorMandat,
  } = useRenouvellementPrelevement(
    selectedAdhesionId,
    selectedAdherent,
    setConfirmationMandat
  );
  const donneesMandatOk =
    watch("iban") &&
    watch("bic") &&
    ibanFormat().test(watch("iban")) &&
    bicFormat().test(watch("bic"));
  const handleVerifyMandat = (event) => {
    if (donneesMandatOk) {
      setParamsMandat({
        iban: watch("iban"),
        bic: watch("bic"),
      });
    }
  };

  const handleChange = (id: string, value: boolean) => {
    setValue("confirmationMandat", value);
    if (value) {
      clearErrors("confirmationMandat");
    }
  };
  useEffect(() => {
    register("confirmationMandat", { required: true });
  }, [register]);
  return (
    <div className={classes.blocPrelevement}>
      <Typography variant="h5">Renouveler par prélèvement</Typography>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)} className={classes.form}>
          <InputField
            label="Titulaire du compte"
            placeholder="Nom Prénom"
            required
            disabled
            maxLength={40}
            name="nomTitulaire"
            register={register}
            value={
              selectedAdherent &&
              selectedAdherent.prenom + " " + selectedAdherent.nom
            }
          />
          <Grid container>
            <InputField
              label="IBAN"
              required
              maxLength={27}
              name="iban"
              pattern={{
                value: ibanFormat(),
                message: "Merci de saisir un numéro d'IBAN valide",
              }}
              disabled={responseMandat ? true : false}
              onBlur={handleVerifyMandat}
              register={register}
              errors={errors.iban}
              value={watch("iban")}
            />
            <InputField
              label="BIC"
              required
              maxLength={11}
              disabled={responseMandat ? true : false}
              name="bic"
              pattern={{
                value: bicFormat(),
                message: "Merci de saisir un numéro de BIC valide",
              }}
              onBlur={handleVerifyMandat}
              register={register}
              errors={errors.bic}
              value={watch("bic")}
            />
          </Grid>
          <Grid container>
            <Checkbox
              name="confirmationMandat"
              label="Je donne mon accord pour être prélevé sur ces coordonnées bancaires"
              value={watch("confirmationMandat")}
              onChange={handleChange}
              required
            />
            {errors.confirmationMandat && (
              <Typography color="error">
                Merci de cocher cette case pour valider votre mandat
              </Typography>
            )}
          </Grid>
          <Grid container className={classes.errorMandat}>
            {fetchingVerifyMandat && <LoadingIcon size="small" />}
            {donneesMandatOk && (
              <span className={classes.verifySepa}>
                {verifyMandat && (
                  <>
                    <Check width={12} className={classes.iconCheckSepa} />{" "}
                    Données valides
                  </>
                )}
                {errorVerifyMandat && (
                  <>
                    <Croix width={12} className={classes.iconCroixSepa} />{" "}
                    Données non valides
                  </>
                )}
              </span>
            )}
          </Grid>
          {responseMandat && "Les informations ont bien été enregistrées"}
          {verifyMandat && (
            <Button
              variant="contained"
              color="primary"
              title={"Valider"}
              type="submit"
              disabled={
                errorVerifyMandat || fetchingVerifyMandat ? true : false
              }
              fetching={fetchingMandat}
            ></Button>
          )}
        </form>
      </FormProvider>
    </div>
  );
};
export default withStyles(styles)(Prelevement);
